import { computed, ref, Ref, watch } from "vue";
import { GenericField } from "@/business/shared/commons/validator/validatorsTypes";
import { RequiredRule } from "@/business/shared/commons/validator/rules/RequiredRule";
import { validator } from "@/business/shared/commons/validator/validator";

export function createEditCampaignValidator() {
  const name: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [new RequiredRule("El nombre es obligatorio")],
  });

  watch(
    () => name.value.val,
    () => {
      validate(name.value);
      if ((name.value.val?.length ?? 0) > 0) {
        name.value.enabled = true;
      }
    }
  );

  function validate(field: GenericField, otherValue?: string): void {
    const validated = validator().validateField(field, otherValue);
    field.errors = validated.errors;
    field.isSuccess = validated.isSuccess;
  }

  const successForm = computed(() => {
    return !name.value.isSuccess;
  });

  function reset(): void {
    name.value.val = "";
    name.value.enabled = false;
    name.value.errors = [];
    name.value.isSuccess = true;
  }

  return {
    name,
    successForm,
    reset,
  };
}
